// 'use client';
// import React from 'react';

// export default function WelcomeSkeleton() {
//     return (
//         <div className="relative w-full h-screen bg-gray-100">
//             {/* Background content skeleton */}
//             <div className="absolute inset-0">
//                 <div className="flex h-full">
//                     <div className="w-1/2 bg-neutral-300 animate-pulse" />
//                     <div className="w-1/2 bg-neutral-300 animate-pulse" />
//                 </div>
//             </div>

//             {/* Centered loading card */}
//             <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-center">
//                 <div className="animate-pulse flex flex-col items-center space-y-4">
//                     <div className="bg-orange-200 w-80 h-80 rounded-full opacity-70" />
//                     {/* <div className="h-6 w-40 bg-gray-300 rounded" />
//                     <div className="h-10 w-48 bg-orange-300 rounded-full" />
//                     <div className="h-4 w-72 bg-gray-300 rounded" /> */}
//                 </div>
//             </div>
//         </div>
//     );
// }

'use client';
import React from 'react';

export default function WelcomePageSkeleton() {
  return (
    <div className="relative w-full h-screen overflow-hidden">
      {/* Background Image Placeholder */}
      <div className="absolute inset-0 bg-neutral-300 animate-pulse" />

      {/* Foreground Content */}
      <div className="relative z-10 flex flex-col items-center justify-center h-full text-center px-4">
        <div className="flex flex-col items-center justify-center space-y-4 bg-orange-200 w-80 h-80 rounded-full animate-pulse">
          {/* Title Skeleton */}
          <div className="h-6 w-32 bg-white rounded" />

          {/* Button Skeleton */}
          <div className="h-10 w-36 bg-white rounded-full border-2 border-orange-400" />

          {/* Subtitle Skeleton */}
          <div className="h-4 w-48 bg-white rounded" />
        </div>
      </div>
    </div>
  );
}

